import { CLOUD_PROVIDER } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

const cloudProviderRequest = (method, url, payload) => ({
  url,
  method,
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload ? { payload } : {}),
  service: serviceName.MASTER_MS,
});

export const getCloudProviders = () => cloudProviderRequest(
  'get',
  `${CLOUD_PROVIDER}?cb=${Date.now()}`,
);

export const createCloudProvider = (cloudProviderName) => cloudProviderRequest(
  'post',
  CLOUD_PROVIDER,
  { cloud_provider_name: cloudProviderName },
);

export const updateCloudProvider = (cloudProviderId, cloudProviderName, isActive) => cloudProviderRequest(
  'put',
  `${CLOUD_PROVIDER}/${cloudProviderId}`,
  {
    cloud_provider_name: cloudProviderName,
    is_active: isActive,
  },
);
